import React, { useState } from 'react';
import { adminApi, apiError } from '../lib/adminApi';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Button } from './ui/button';

export const AdminPasswordDialog = ({ open, onOpenChange, onChanged }) => {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const submit = async e => {
    e.preventDefault(); setBusy(true); setError('');
    try {
      await adminApi.post('/admin/auth/password', { current_password: current, new_password: next });
      setCurrent(''); setNext(''); onOpenChange(false); onChanged();
    } catch (err) { setError(apiError(err)); } finally { setBusy(false); }
  };
  return <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="admin-password-dialog">
      <DialogHeader><DialogTitle>Promjena lozinke</DialogTitle><DialogDescription>Nakon promjene ponovno se prijavite. Sve postojeće prijave bit će odjavljene.</DialogDescription></DialogHeader>
      <form className="space-y-4" onSubmit={submit} data-testid="admin-password-form">
        <div><Label htmlFor="old-password">Trenutna lozinka</Label><Input id="old-password" type="password" autoComplete="current-password" required value={current} onChange={e => setCurrent(e.target.value)} data-testid="admin-current-password" /></div>
        <div><Label htmlFor="new-password">Nova lozinka (najmanje 12 znakova)</Label><Input id="new-password" type="password" autoComplete="new-password" required minLength={12} maxLength={72} value={next} onChange={e => setNext(e.target.value)} data-testid="admin-new-password" /></div>
        {error && <p className="text-sm text-red-700" role="alert" data-testid="admin-password-error">{error}</p>}
        <Button disabled={busy} type="submit" data-testid="admin-password-save">Spremi novu lozinku</Button>
      </form>
    </DialogContent>
  </Dialog>;
};